module.exports = __webpack_public_path__ + "site/img/Maps_8WanChai.31133f4d.jpg";